import { Component, OnInit, forwardRef, Input, ViewChild, NgZone } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { PagerControlComponent } from '../../pager/pager-control.component';
import { BillingInvoiceItemEditInfo } from 'src/app/model/billing/billing-invoice-item-edit-info';
import { Base64ToBlobService } from 'src/app/services/base64-to-blob.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { BillingInvoiceCreditEntityService } from '../../../../services/billing/billing-invoice/billing-invoice-credit-entity.service';
import { BillingInvoiceEditService } from '../../../../services/billing/billing-invoice/billing-invoice-edit.service';
import { DownloadLocalFileService } from '../../../../services/download-local-file.service';

export const BILLING_INVOICE_ITEM_CREDIT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BillingInvoiceItemEntityCreditEditComponent),
  multi: true,
};

@Component({
  selector: 'app-billing-invoice-item-entity-credit-edit',
  providers: [BILLING_INVOICE_ITEM_CREDIT_CONTROL_VALUE_ACCESSOR],
  templateUrl: './billing-invoice-item-entity-credit-edit.component.html',
  styleUrls: ['./billing-invoice-item-entity-credit-edit.component.css']
})
export class BillingInvoiceItemEntityCreditEditComponent implements ControlValueAccessor, OnInit {

  @Input() id: string;
  hideElement = true;
  loadingAction: boolean;
  dataSource = new MatTableDataSource([]);
  displayedColumns: string[] = ['protocol', 'patientFullName', 'credential',
                                'practiceName', 'serviceName', 'companyName',
                                'amount', 'amountDebit', 'debitTypeName', 'Star'];

  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  onChange;
  items: BillingInvoiceItemEditInfo[];

  constructor( private base64ToBlobService: Base64ToBlobService,
               private zone: NgZone,
               private downloadLocalFileService: DownloadLocalFileService,
               private billingInvoiceEditService: BillingInvoiceEditService,
               private billingInvoiceCreditEntityService: BillingInvoiceCreditEntityService,
               private notificationToastService: NotificationToastService ) { }

  ngOnInit() {
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
  }

  writeValue(items: BillingInvoiceItemEditInfo[]): void {
    this.items = items;
    this.pager.setItems(this.items);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  deleteItem(item: BillingInvoiceItemEditInfo) {
    const index = this.items.indexOf(item, 0);
    if (index > -1) {
      this.items.splice(index, 1);
      this.pager.setItems(this.items);
      this.changeBillingInvoiceItems();
   }
  }

  changeBillingInvoiceItems(): void {
    if (this.onChange) {
      this.onChange(this.items);
    }
  }

  async export() {
    try {
      if ( this.pager.getAllItems().length > 0 ) {
        this.loadingAction = true;
        const file = await this.billingInvoiceCreditEntityService.createExcelCredit(this.items);
        const parentInvoiceNumber =  this.billingInvoiceEditService.getParentInvoiceCompleteNumber();
        this.downloadLocalFileService.downLoadFile( file,
          `Factura-${ parentInvoiceNumber }`, 'xlsx'  );
      }
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
    } finally {
      this.loadingAction = false;
    }
  }

  async import(event) {

      for (let index = 0; index < event.length; index++) {
        const element = event[index];
        const reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = (_event) =>  {
          this.zone.run(async () => {
            try {
              this.loadingAction = true;
              const base64Url =  <string>reader.result;
              const fileBase64 = base64Url.split('base64,')[1];
              const info = await this.billingInvoiceCreditEntityService.
                  billingInvoiceItemEditInfosAdjustment(fileBase64, this.pager.getAllItems());
              this.items = info;
              this.pager.setItems(this.items);
              this.changeBillingInvoiceItems();
            } catch ( err ) {
              this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
            } finally {
              this.loadingAction = false;
            }
          });
        }
      }
  }
}


// import { Component, OnInit, forwardRef, Input, ViewChild, NgZone } from '@angular/core';
// import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// import { MatTableDataSource } from '@angular/material';
// import { PagerControlComponent } from '../../pager/pager-control.component';
// import { BillingInvoiceItemEditInfo } from 'src/app/model/billing/billing-invoice-item-edit-info';
// import { Base64ToBlobService } from 'src/app/services/base64-to-blob.service';
// import { NotificationToastService } from 'src/app/services/notification-toast.service';
// import { BillingInvoiceCreditEntityService } from '../../../../services/billing/billing-invoice/billing-invoice-credit-entity.service';
// import { BillingInvoiceEditService } from '../../../../services/billing/billing-invoice/billing-invoice-edit.service';
// import { DownloadLocalFileService } from '../../../../services/download-local-file.service';

// export const BILLING_INVOICE_ITEM_CREDIT_CONTROL_VALUE_ACCESSOR: any = {
//   provide: NG_VALUE_ACCESSOR,
//   useExisting: forwardRef(() => BillingInvoiceItemEntityCreditEditComponent),
//   multi: true,
// };

// @Component({
//   selector: 'app-billing-invoice-item-entity-credit-edit',
//   providers: [BILLING_INVOICE_ITEM_CREDIT_CONTROL_VALUE_ACCESSOR],
//   templateUrl: './billing-invoice-item-entity-credit-edit.component.html',
//   styleUrls: ['./billing-invoice-item-entity-credit-edit.component.css']
// })
// export class BillingInvoiceItemEntityCreditEditComponent implements ControlValueAccessor, OnInit {

//   @Input() id: string;
//   hideElement = true;
//   loadingAction: boolean;
//   dataSource = new MatTableDataSource([]);
//   displayedColumns: string[] = ['protocol', 'patientFullName', 'credential',
//                                 'practiceName', 'serviceName', 'companyName',
//                                 'amount', 'amountDebit', 'debitTypeName', 'Star'];

//   @ViewChild('pager') pager: PagerControlComponent;
//   onChange;
//   items: BillingInvoiceItemEditInfo[];

//   constructor( private base64ToBlobService: Base64ToBlobService,
//                private zone: NgZone,
//                private downloadLocalFileService: DownloadLocalFileService,
//                private billingInvoiceEditService: BillingInvoiceEditService,
//                private billingInvoiceCreditEntityService: BillingInvoiceCreditEntityService,
//                private notificationToastService: NotificationToastService ) { }

//   ngOnInit() {
//   }

//   selectedPageIndexChange(pagedItems: any[]) {
//     this.dataSource = new MatTableDataSource(pagedItems);
//   }

//   writeValue(items: BillingInvoiceItemEditInfo[]): void {
//     this.items = items;
//     this.pager.setItems(this.items);
//   }

//   registerOnChange(fn: any): void {
//     this.onChange = fn;
//   }

//   registerOnTouched(fn: any): void {
//   }

//   setDisabledState?(isDisabled: boolean): void {
//   }

//   deleteItem(item: BillingInvoiceItemEditInfo) {
//     const index = this.items.indexOf(item, 0);
//     if (index > -1) {
//       this.items.splice(index, 1);
//       this.pager.setItems(this.items);
//       this.changeBillingInvoiceItems();
//    }
//   }

//   changeBillingInvoiceItems(): void {
//     if (this.onChange) {
//       this.onChange(this.items);
//     }
//   }

//   async export() {
//     try {
//       if ( this.pager.getAllItems().length > 0 ) {
//         this.loadingAction = true;

//         const file = await this.billingInvoiceCreditEntityService.
//             createExcelCredit(this.items);

//         const number = this.billingInvoiceEditService.
//             getParentInvoiceCompleteNumber();
//         const name = `Factura ${{ number }}`;

//         this.downloadLocalFileService.downLoadFile(file, name, 'xlsx');
//       }
//     } catch ( err ) {
//       this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
//     } finally {
//       this.loadingAction = false;
//     }
//   }

//   async import(event) {

//       for (let index = 0; index < event.length; index++) {
//         const element = event[index];
//         const reader = new FileReader();
//         reader.readAsDataURL(element);
//         reader.onload = (_event) =>  {
//           this.zone.run(async () => {
//             try {
//               this.loadingAction = true;
//               const base64Url =  <string>reader.result;
//               const fileBase64 = base64Url.split('base64,')[1];
//               const info = await this.billingInvoiceCreditEntityService.
//                   billingInvoiceItemEditInfosAdjustment(fileBase64, this.pager.getAllItems());
//               this.items = info;
//               this.pager.setItems(this.items);
//               this.changeBillingInvoiceItems();
//             } catch ( err ) {
//               this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
//             } finally {
//               this.loadingAction = false;
//             }
//           });
//         }
//       }
//   }
// }
